export default __webpack_public_path__ + "static/media/check-icon.340d928e.svg";